import type { ExportKey } from '../hooks/useExports'
import type { ExportCreditLimit, ExportLoan, ExportRedirection, ExportRepayment } from '../services/exportServices'

// The columns of each export, in the order its rows hold them. The header row of the CSV lists them,
// also when the export has no record.
const LOAN_COLUMNS = [
    'id',
    'status',
    'amount',
    'currency',
    'createdAt',
    'paidAt',
    'repaidAt',
    'billingType',
    'billingNumber',
    'billingDate',
    'invoiceDueDate',
    'invoiceAmount',
    'invoicePaymentTermsType',
    'invoiceRepaymentPeriod',
    'debtorName',
    'debtorIdentifierValue',
    'debtorIdentifierType',
    'beneficiaryCompanyName',
    'beneficiaryContactName',
    'beneficiaryContactEmail',
    'beneficiaryBusinessIdentifierValue',
    'beneficiaryBusinessIdentifierType',
    'blockReasons',
    'refusalReasons'
] as const satisfies ReadonlyArray<keyof ExportLoan>

const CREDIT_LIMIT_COLUMNS = [
    'id',
    'updatedAt',
    'status',
    'claimedCurrency',
    'allocationGuarantor',
    'allocationOutstandingAmount',
    'allocationAmount',
    'debtorName',
    'debtorIdentifierValue',
    'debtorIdentifierType'
] as const satisfies ReadonlyArray<keyof ExportCreditLimit>

const REPAYMENT_COLUMNS = [
    'id',
    'createdAt',
    'sender',
    'label',
    'amount',
    'currency',
    'transactionStatus',
    'allocationsStatus',
    'invoiceNumbers',
    'loanIds'
] as const satisfies ReadonlyArray<keyof ExportRepayment>

const REDIRECTION_COLUMNS = [
    'id',
    'createdAt',
    'currency',
    'amount',
    'status',
    'label',
    'repaymentId'
] as const satisfies ReadonlyArray<keyof ExportRedirection>

export const EXPORT_COLUMNS = {
    loans: LOAN_COLUMNS,
    creditLimits: CREDIT_LIMIT_COLUMNS,
    repayments: REPAYMENT_COLUMNS,
    redirections: REDIRECTION_COLUMNS
} as const satisfies Record<ExportKey, ReadonlyArray<string>>
